import firebase from 'firebase';
import _ from 'lodash';

export const getUnits = async (id) => {
  const result = [];
  let req = null;

  const units = await firebase.firestore()
    .collection('units')
    .get();

  const work_units = [];

  units.forEach((subDoc) => {
    const data = subDoc.data();
    work_units.push({
      label: data.name || '',
      value: subDoc.id,
      id: subDoc.id || null,
      isMain: true
    });
  });


  req = firebase.firestore()
    .collection('projects')
    .doc(id)
    .collection('units')
    .orderBy("index", 'asc');

  const data = await req.get();

  data.forEach((subDoc) => {
    const data = subDoc.data();
    result.push({
      label: data.name || '',
      value: subDoc.id,
      id: subDoc.id || null,
    });
  });

  return [...work_units, ..._.orderBy(result, '_data.index', ['desc'])];
};



// WEBPACK FOOTER //
// ./src/firestore/units.js